import { Model } from '@vuex-orm/core';
import { Call } from '../models/Call';
import { Me } from '../models/Me';

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class Schedule extends Model {
    static entity = 'schedules'

    static primaryKey = ['volunteer_id', 'date', 'period_id']

    static fields () {
      return {
        volunteer_id: this.attr(null), // @todo - put in relationship
        date: this.attr(null),
        period_id: this.attr(null),
        calls: this.attr([]),

        callItems: this.hasManyBy(Call, 'calls'),

        active: this.attr(false) // @nb - this is managed by us, until we get time sorted out
      };
    }

    static compositeKey (json) {
      return this.primaryKey.map((key) => json[key]).join('_');
    }

    static findForJson (json) {
      const compositeKey = this.compositeKey(json);
      return Schedule.query().where('$id', compositeKey).first();
    }

    static async loadActiveSchedule () {
      // @todo - use real volunteerId
      const me = await Me.getForLoggedInUser();
      const schedules = await Schedule.$fetch({ query: { volunteer_id: me.volunteer_id, active: true }});
      if (schedules.length) {
        const schedule = await Schedule.findForJson(schedules[0]);
        schedule.toggleActive();
        schedule.calls.forEach(async (callId) => {
          await Call.load(callId);
        });
      }
    }

    async toggleActive () {
      await Schedule.update({ where: (item) => item.$id === this.$id, data: { active: true }});
    }

    /**
     * Axios default overrides
     * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
     */
    static methodConf = {
      http: {
        url: 'regicall/schedules'
      },
      methods: {
      }
    }
}
